import { TReduxActions } from '../../types/redux';
import { IServiceMessageState } from '../../types/redux/states/ServiceMessageState';
import { EServiceMessageActionTypes } from '../../constants/actionTypes/serviceMessageActions';

export const initialState: IServiceMessageState = {
  isNewYearAlertShown: false,
  isNewYearAlertShouldShown: false,
};

export function serviceMessageReducer(state: IServiceMessageState = initialState, action: TReduxActions) {
  switch (action.type) {
    case EServiceMessageActionTypes.SET_NEW_YEAR_SHOWN:
      return {
        ...state,
        isNewYearAlertShown: action.payload,
      };
    case EServiceMessageActionTypes.SET_NEW_YEAR_SHOULD_SHOWN:
      return {
        ...state,
        isNewYearAlertShouldShown: action.payload,
      };
    default:
      return state;
  }
}
